import DynamicLayout from '@rebuild/views/layout/DynamicLayout.vue';
import DynamicHome from '@rebuild/views/home/DynamicHome.vue';
import ComponentFrame from '@rebuild/views/frame/ComponentFrame.vue';
import ComponentFrameSub from '@rebuild/views/frame/ComponentFrameSub.vue';
import DynamicComponentDemo from '@rebuild/views/frame/DynamicComponentDemo.vue';

const isDev = process.env.NODE_ENV === 'development';

// 动态模板路径 - 统一使用 DynamicLayout 做中转识别
export const ENTERPRISE_REBUILD_ROUTERS = [
	// ===================== 组件示例路由 =====================
	{
		path: 'enterprise/components/:directory',
		component: DynamicComponentDemo,
		beforeEnter: (to, from, next) => {
			if (isDev) {
				return next();
			}
			// 避免在生产环境访问
			return next({
				path: `irm-mobile/enterprise/tmpl`,
				query: to.query
			});
		}
	},

	// ===================== 单页面 =====================
	{
		path: 'enterprise/:tmpl(flow|tmpl)',
		component: DynamicLayout,
		children: [
			{
				path: '',
				name: 'single_template_home_root',
				component: DynamicHome
			},
			{
				path: 'index',
				name: 'single_template_home',
				component: DynamicHome
			},

			// 历史定制路由
			{
				path: 'nine_index',
				name: 'single_template_home_nine',
				component: DynamicHome,
				meta: {
					channel: 'nine'
				}
			},
			{
				path: 'ebmedical_index',
				name: 'single_template_home_ebmedical',
				component: DynamicHome,
				meta: {
					channel: 'ebmedical'
				}
			},

			// 组件、子组件入口
			{
				path: ':moduleId/:subPath',
				name: 'single_component_frame_sub',
				component: ComponentFrameSub
			},
			{
				path: ':moduleId',
				name: 'single_component_frame',
				component: ComponentFrame
			}
		]
	},

	// ===================== 多页面 =====================
	{
		path: 'enterprise/:tmpl(cardM)/:tmplId',
		component: DynamicLayout,
		children: [
			{
				path: '',
				name: 'multi_template_home_root',
				component: DynamicHome
			},
			{
				path: 'index',
				name: 'multi_template_home',
				component: DynamicHome
			},

			// 组件、子组件入口
			{
				path: ':moduleId/:subPath',
				name: 'multi_component_frame_sub',
				component: ComponentFrameSub
			},
			{
				path: ':moduleId',
				name: 'multi_component_frame',
				component: ComponentFrame
			}
		]
	}
];
